
<div>
  <el-row class="logapp">
    <el-col :span="12" :offset="6" style="text-align: center">
      Utilisateur crée
    </el-col>
    <el-col :span="12" :offset="6" style="text-align: center; margin-top: 20px;">
      <el-button type="primary" @click="gotoRestaurant">Aller au restaurant</el-button>
    </el-col>
  </el-row>
</div>
